var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.9.7c12.722 0 23.034 10.313 23.034 23.034 0 4.742-1.463 9.369-4.191 13.248L32.238 63.3l-18.92-26.502C5.992 26.535 8.372 12.276 18.634 4.95A22.832 22.832 0 0131.901.7zm0 11.354c-6.28 0-11.372 5.154-11.372 11.512 0 6.357 5.092 11.511 11.373 11.511 6.28 0 11.372-5.154 11.372-11.511 0-6.358-5.091-11.512-11.372-11.512z","fill":"currentColor","fillRule":"evenodd"}));
}

Marker.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Marker;

Marker.default = Marker;
